import React from 'react';
import './MarketDetailsModal.css';

interface MarketDetailsModalProps {
    show: boolean;
    onHide: () => void;
    size: string;
    centered: boolean;
    style: {
        position: string,
        top: string,
        left: string,
        transform: string,
        width: string,
        maxWidth: string,
    },
    data: {
        destination: string;
        load_date: string;
        ticket_number: string;
        lease: string;
        gross_barrels: number;
        net_barrels: number;
        carrier: string;
    }[];
}

export const MarketDetailsModal: React.FC<MarketDetailsModalProps> = ({ show, onHide, data }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <button 
                        onClick={onHide} 
                        className="close-button"
                    >
                        Close
                    </button>
                    <h2 className="modal-title">Market: {data[0]?.destination}</h2>
                </div>
                <div className="modal-body-scrollable">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Ticket Number</th>
                                <th>Lease</th>
                                <th>Gross Volume</th>
                                <th>Net Volume</th>
                                <th>Carrier</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.load_date}</td>
                                    <td>{item.ticket_number}</td>
                                    <td>{item.lease}</td>
                                    <td>{item.gross_barrels}</td>
                                    <td>{item.net_barrels}</td>
                                    <td>{item.carrier}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};